export const useScrollToTop = () => {
  const scrollToTop = (behavior: ScrollBehavior = 'auto') => {
    window.scrollTo({ top: 0, behavior })
  }

  return scrollToTop
}
